import React, { ReactElement } from 'react';
import { Message } from 'slovlex-idsk-react-components';
import HeadingWithLink from '../module/GlobalErrors/component/HeadingWithLink';
import './forbiddenPage.scss';

interface Props {
  message?: string;
  onClear?: () => void;
}

const ForbiddenPage = ({
  message = 'Nemáte oprávnenie na vykonávanie požadovanej akcie.',
  onClear,
}: Props): ReactElement => (
  <>
    <Message
      onClear={onClear}
      className="forbidden-error-message"
      type="error"
    >
      <HeadingWithLink message={message} />
    </Message>
  </>
);

export default ForbiddenPage;
